class ProductOptionModal {
  constructor(modalId) {
    this.modalId = modalId;
    this.modal = null;
    this.openButton = null;
    this.closeButton = null;
    this.focusedElementBeforeModal = null;
    this.init();
  }

  init() {
    this.modal = document.getElementById(this.modalId);
    this.openButton = document.querySelector(`[aria-controls="${this.modalId}"]`);
    this.closeButton = this.modal?.querySelector('.product-option-modal__close');

    if (!this.modal || !this.openButton || !this.closeButton) return;

    this.setupEventListeners();
    this.setupFocusTrap();
  }

  setupEventListeners() {
    // モーダルを開く
    this.openButton.addEventListener('click', () => this.open());

    // モーダルを閉じる
    this.closeButton.addEventListener('click', () => this.close());

    // 背景クリックで閉じる
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.close();
      }
    });

    // Escapeキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        this.close();
      }
    });

    // オプション選択時の処理
    const optionInputs = this.modal.querySelectorAll('input[type="radio"]');
    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateSelectedOption(input);
        // お気に入りフロー（custom-product-wishlist-modal.liquid）からの変更時は自動クローズしない
        // （close() が body の overflow を解除し、直後に開くお気に入りモーダルの背景固定を壊すため）
        if (this.modal.dataset.bundle !== 'true' && !this.isWishlistFlowActive()) {
          setTimeout(() => this.close(), 300);
        }
      });
    });
  }

  open() {
    this.focusedElementBeforeModal = document.activeElement;
    this.modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    // 最初のフォーカス可能な要素にフォーカス
    setTimeout(() => {
      this.closeButton.focus();
    }, 100);

    // ARIA属性の更新
    this.openButton.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.modal.classList.remove('is-active');
    document.body.style.overflow = '';

    // フォーカスを戻す
    if (this.focusedElementBeforeModal) {
      this.focusedElementBeforeModal.focus();
    }

    // ARIA属性の更新
    this.openButton.setAttribute('aria-expanded', 'false');
  }

  updateSelectedOption(input) {
    const optionValue = input.value;
    const optionName = input.name;

    // ボタンのテキストを更新
    const buttonText = this.openButton.querySelector('.option-modal-button__text');
    if (buttonText) {
			const optionName = this.openButton.dataset.optionName;
      buttonText.textContent = optionName + ' ' + optionValue;
    }

    // オプション名の表示を更新（存在する場合）
    const optionDisplay = document.getElementById(`product${optionName}Name`);
    if (optionDisplay) {
      optionDisplay.textContent = optionValue;
    }

    const bisTriggerSize = input.getAttribute('data-bis-trigger');
    const variantId = input.getAttribute('data-variant-id');
    // 在庫切れサイズ選択時の挙動
    // モバイル（画面幅 1023px 以下）: .product-form までページ内スクロール
    // PC（1024px 以上）: 何もしない（ページ内スクロール・BISポップアップ共に実行しない）
    // お気に入りフローからの変更時はスクロールしない
    if (bisTriggerSize === 'true' && !this.isWishlistFlowActive()) {
      if (window.matchMedia('(max-width: 1023px)').matches) {
        this.scrollToProductForm();
      }
    }

    if (variantId && window.__wishlistModal && typeof window.__wishlistModal.applyVariant === 'function') {
      window.__wishlistModal.applyVariant(variantId);
    }
  }

  // お気に入りフロー中（サイズ選択→お気に入り登録）かどうか
  isWishlistFlowActive() {
    return !!(window.__wishlistModal && window.__wishlistModal.selecting === true);
  }

  scrollToProductForm() {
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;

    // サイズモーダルは選択後 300ms で閉じ、body の overflow が解除される。
    // overflow:hidden の間はスクロールできないため、閉じた後にスクロールを実行する。
    setTimeout(() => {
      const stickyHeader = document.querySelector('sticky-header');
      const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
      const top = productForm.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 400);
  }

  setupFocusTrap() {
    const focusableElements = this.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    this.modal.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });
  }
}

// 複数のモーダルを管理するクラス
class ProductOptionModalsManager {
  constructor() {
    this.modals = [];
    this.init();
  }

  init() {
    // すべてのオプションモーダルを検索
    const modalElements = document.querySelectorAll('.product-option-modal');
    
    modalElements.forEach((modalElement) => {
      const modalId = modalElement.id;
      if (modalId) {
        const modal = new ProductOptionModal(modalId);
        this.modals.push(modal);
      }
    });
  }
}

// 初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductOptionModalsManager();
  });
} else {
  new ProductOptionModalsManager();
}

